import React, { useMemo } from 'react';
import styled from "styled-components";
import isMobile from "is-mobile";

export function CarParkingBookedIcon(props: Props) {
  const {am, pm} = props;

  const carParkIcon = useMemo(() => {
    return isMobile() ? "/assets/icons/car-park-icon-small.svg" : "/assets/icons/car-park-icon.svg";
  }, [])

  if (!am && !pm) return null;
  return (<>
    {am && <AmOrAllDayParking src={carParkIcon} alt={"Car parking booked"} />}
    {pm && <PmParking src={carParkIcon} alt={"Afternoon car parking booked"} />}
  </>)
}

interface Props {
  am: boolean;
  pm: boolean;
}

const AmOrAllDayParking = styled.img`
  position: absolute;
  z-index: 10;
  top: -6px;
  left: -6%;
`

const PmParking = styled.img`
  position: absolute;
  z-index: 10;
  top: -6px;
  right: -6%;
`
